module.exports = __webpack_public_path__ + "img/shovel-snow.411d7faf.svg";